
import { PageRequest } from "@/store/shared/entity";
import CreateCustomer from "./component/create-customer.vue";
import EditCustomer from "./component/edit-customer.vue";

import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins, PageResultListMixins ,appConst} from "@/lib";

class PageCustomerRequest extends PageRequest {
  name: string;
}

@Component({
  name: "customer.list", //设置页面对应route的名字，以便keepalive进行缓存
  components: { CreateCustomer, EditCustomer },
})
export default class Customer extends Mixins(PageResultBaseMixins, PageResultModalMixins, PageResultListMixins) {
  /**
   * section buttons
   */
  sectionButtons = { ...this.addBtn() };

  /**
   * search-page bind data
   */
  data: any = {
    model: new PageCustomerRequest(),
    queryAction: "system/customer/getAll",
    isAutoQuery: true,
    cols: this.columns,
  };

  /**
   * table columns
   */
  get columns() {
    return [
      { title: this.L("app.Customer.Name"), key: "name", tooltip: true,width:330},
      { title: this.L("app.Customer.Address"), key: "address", tooltip: true,width:400 },
      { title: this.L("app.Customer.CustomerBusinessGroupIdList"), key: "customerBusinessGroupIds",minWidth:150, tooltip: true },
     // { title: this.L("app.Customer.PaymentDays"), key: "paymentDays", tooltip: true },

          this.$util.render.codeColumn(
        "app.Customer.PaymentDays",
        "paymentDays",
        () =>
          this.getCodeListByCategory(
            appConst.codeCategory.payment
          ),
        { width: 150 }
      ),
      {
        title: this.L("app.Customer.BankFee"),
        key: "bankDeductionRatio",
        render: (h: any, params: any) => {
          return h("span", `${params.row.bankCharges > 0 ? `$${this.$util.format.amount(params.row.bankCharges, 1)}` : params.row.bankDeductionRatio > 0 ? "" : "$0.0"} ${params.row.bankDeductionRatio > 0 ? `${params.row.bankCharges > 0 ? "+" : ""} ${params.row.bankDeductionRatio}%` : ""}`);
        },
         width: 150 
      },

      this.$util.render.actions(this.colButtons),
    ];
  }

  colButtonCheck = (row) => {
    return !row.isStatic;
  };

  /**
   * table 操作列按钮
   */
  get colButtons():ActionButtonConfig[]{ 
            return [
                {
                  label: "Action.Edit",
                  permission: "RIMS.Customer.Edit",
                  callback: async (row:any) => {
                  await this.$store.dispatch("system/customer/get",{id:row.id});
                  this.open("edit-modal");
          }                                         
       }, 
                this.colDeleteBtn( row => this.colButtonCheck(row)),
            ]
        }

  /**
   * reset 回调
   */
  reset() {
    this.data.model = new PageCustomerRequest();
  }
}
